<template>
  <div>
    <div class="actions">
      <el-button
        class="main-button"
        type="primary"
        size="mini"
        @click="handleCreate"
        v-if="isSuper"
        >创建节点</el-button
      >
    </div>
    <div class="mt-10">
      <el-table :data="nodes">
        <el-table-column prop="name" label="节点"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column label="操作" align="center" width="70" v-if="isSuper">
          <template slot-scope="scope">
            <div class="table-actions">
              <i
                class="el-icon-edit-outline icon-button edit-icon-button"
                @click="handleEdit(scope.$index, scope.row)"
              ></i>
              <DeleteIconButton
                @delete="handleDelete(scope.row)"
              ></DeleteIconButton>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <NodeCreateEditDialog
      v-if="dialogVisible"
      :node="dialogNode"
      @close="handleClose"
      @change="handleChange"
    ></NodeCreateEditDialog>
  </div>
</template>

<script>
import { ClaimRolePermissionMixin, OopsErrorELMessage } from "@/mixins";
import DeleteIconButton from "@/components/DeleteIconButton";
import NodeCreateEditDialog from "@/components/NodeCreateEditDialog";
export default {
  name: "Nodes",
  mixins: [ClaimRolePermissionMixin, OopsErrorELMessage],
  components: {
    DeleteIconButton,
    NodeCreateEditDialog
  },
  data() {
    return {
      nodes: [],
      dialogVisible: false,
      dialogNode: null
    };
  },
  created() {
    this.listNodes();
  },
  methods: {
    listNodes() {
      this.$http.get("/api/v1/nodes").then(resp => {
        this.nodes = resp.data;
      });
    },
    handleCreate() {
      this.dialogNode = null;
      this.dialogVisible = true;
    },
    handleEdit(_, node) {
      this.dialogNode = { ...node };
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleChange(node) {
      let isCreate = node.id === 0;
      this.$http({
        method: isCreate ? "POST" : "PATCH",
        url: `/api/v1/nodes${isCreate ? "" : "/" + node.id}`,
        data: {
          name: node.name,
          description: node.description
        }
      })
        .then(resp => {
          if (isCreate) {
            this.nodes.push(resp.data);
          } else {
            let idx = this.nodes.findIndex(n => n.id === node.id);
            this.nodes.splice(idx, 1, resp.data);
          }
          this.dialogVisible = false;
        })
        .catch(err => {
          this.oopsError(err);
          this.dialogVisible = false;
        });
    },
    handleDelete(node) {
      this.$http
        .delete(`/api/v1/nodes/${node.id}`)
        .then(() => {
          let idx = this.nodes.findIndex(n => n.id === node.id);
          this.nodes.splice(idx, 1);
          this.$eventbus.$emit("ResetDeleteIconButton");
        })
        .catch(err => {
          this.oopsError(err);
          this.$eventbus.$emit("ResetDeleteIconButton");
        });
    }
  }
};
</script>

<style scoped></style>
